import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';

export function patientDocumentsLoad(patient_id, filters){
  const url = `/${API_VERSION_ONE}/patients/${patient_id}/patient_documents`;
  const method = 'GET'
  return {
    type: 'PATIENT_DOCUMENTS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function patientDocumentLoad(patient_id, id, filters){
  const url = `/${API_VERSION_ONE}/patients/${patient_id}/patient_documents/${id}`;
  const method = 'GET'

  return {
    type: 'PATIENT_DOCUMENT_LOAD',
    payload: handleAPI(url,filters,method)
  };
}

export function patientDocumentCreate(patient_id, data, filters){
  const url = `/${API_VERSION_ONE}/patients/${patient_id}/patient_documents`;
  const method= 'POST'
  return {
    type: 'PATIENT_DOCUMENT_CREATE',
    payload: handleAPI(url,filters,method, {patient_document: {...data}})
  }
}

export function patientDocumentUpdate(patient_id, data, filters){
  const url = `/${API_VERSION_ONE}/patients/${patient_id}/patient_documents/${data.id}`;
  const method = "PUT"
  return {
    type: 'PATIENT_DOCUMENT_UPDATE',
    payload: handleAPI(url,filters,method, {patient_document: {...data}})
  }
}

export function patientDocumentDelete(patient_id, id, filters) {
  const url = `/${API_VERSION_ONE}/patients/${patient_id}/patient_documents/${id}`;
  const method = 'DELETE';

  return {
    type: 'PATIENT_DOCUMENT_DELETE',
    payload: new Promise((resolve, reject) => {
      handleAPI(url, filters, method)
        .then(response => {
          resolve({ id: id, ...response });
        })
        .catch(err => {
          reject(err);
        });
    })
  };
}

export function patientDocumentEdit(id) {
  return {
    type: 'PATIENT_DOCUMENT_EDIT',
    id,
  };
}

export function patientDocumentEditCancel() {
  return {
    type: 'PATIENT_DOCUMENT_EDIT_CANCEL'
  };
}
